import { render, staticRenderFns } from "./NotesPanel.vue?vue&type=template&id=6798b87e&"
import script from "./NotesPanel.vue?vue&type=script&lang=js&"
export * from "./NotesPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6798b87e')) {
      api.createRecord('6798b87e', component.options)
    } else {
      api.reload('6798b87e', component.options)
    }
    module.hot.accept("./NotesPanel.vue?vue&type=template&id=6798b87e&", function () {
      api.rerender('6798b87e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/coLiving/components/NotesPanel.vue"
export default component.exports